import React from "react";
import { Col, Result, Row } from "antd";
import { Helmet } from "react-helmet";
import { StyledLink } from "./styled-components/components";
import { useHistory } from "react-router";
import { useSelector } from "react-redux";
import constants from "./Redux/constants";

const PageNotFound = () => {
  const history = useHistory();
  const { userRole } = useSelector((state) => state.userStore);
  const goHome = () => {
    if (userRole === constants.roles.client) {
      history.push("/client/home");
    }
    if (userRole === constants.roles.consultant) {
      history.push("/consultant/home");
    }
  };
  return (
    <Col>
      <Helmet title={`404 | Unicon`} />
      <Result title="404" status="404" subTitle="The Page is unavailable" />
      <Row justify="center">
        <StyledLink onClick={goHome}>Home</StyledLink>
      </Row>
    </Col>
  );
};

export default PageNotFound;
